import { render, staticRenderFns } from "./UploadPhotoButton.vue?vue&type=template&id=ea79aabe&scoped=true"
import script from "./UploadPhotoButton.vue?vue&type=script&lang=js"
export * from "./UploadPhotoButton.vue?vue&type=script&lang=js"
import style0 from "./UploadPhotoButton.vue?vue&type=style&index=0&id=ea79aabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea79aabe",
  null
  
)

export default component.exports